import { ColumnProps } from 'primereact/column';
import { formatDateAndTime } from '@/utils/formatDate';

export const getTableColumns = (): ColumnProps[] => [
  {
    field: 'bl',
    header: 'BL',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'viaje',
    header: 'Viaje',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'pol',
    header: 'POL',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'pod',
    header: 'POD',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'identificador',
    header: 'Nro. chasis',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'tipo',
    header: 'Tipo',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'descripcion',
    header: 'Descripción',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'marca',
    header: 'Marca',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'modelo',
    header: 'Modelo',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'lugarEntrega',
    header: 'Lugar de entrega',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'fechaDescarga',
    header: 'Fecha y Hora de descarga',
    filter: true,
    showFilterMenu: true,
    sortable: true,
    body: (rowData) => formatDateAndTime(rowData.fechaRegistro),
  },
];
